var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
  'preview-row': true,
  'has-text-center': true,
  selected: _vm.selected,
  green: _vm.preview.validation_status === 'validated'
}},[_c('button-link',{attrs:{"text":_vm.label,"path":_vm.previewPath}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }